import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Icon from '@material-ui/core/Icon';

// CONSTANTS
import { ROUTE_RESULTS, ROUTE_START } from '@/constants/routes';

// UTILITY
import store from '@/utility/store';
import { isHomeLocation } from '@/utility/routes';

// COMPONENTS
import BannerWithApps from '@/components/Banners/BannerWithApps';
import BannerFMBResults from '@/components/Banners/BannerFMBResults';
import RouterLink from '@/components/Link';

// ASSETS
import { ReactComponent as PartyIcon } from '@/assets/images/icons/party-popper.svg';
import { ReactComponent as FaceIcon } from '@/assets/images/icons/thinking-face.svg';

function BannerFMB({ analyticsLocation }) {
  const [t] = useTranslation();
  const show_reg_fmb = useRef(store.get('show_reg_fmb')).current;
  const { unique_id, hasApps } = useSelector(({ auth }) => ({
    unique_id: auth.unique_id,
    hasApps: auth.user?.content_count?.apps_have > 0,
  }));

  const showRegVer = hasApps && show_reg_fmb;

  if (unique_id) {
    return (
      <BannerFMBResults
        title={t('homeAuth.banners.fmb.title')}
        subtitle={t('homeAuth.banners.fmb.subtitle')}
        btnText={t('buttons.seeResults')}
        btnProps={{
          component: RouterLink,
          to: {
            pathname: ROUTE_RESULTS,
            state: {
              fromHome: isHomeLocation(),
            },
          },
          location: analyticsLocation,
        }}
      />
    );
  }

  return (
    <BannerWithApps
      title={
        <>
          {t(`homeAuth.banners.${showRegVer ? 'registration' : 'regular'}.title`)}{' '}
          <Icon fontSize="inherit" component={showRegVer ? PartyIcon : FaceIcon} />
        </>
      }
      subtitle={t(`homeAuth.banners.${showRegVer ? 'registration' : 'regular'}.subtitle`)}
      btnText={t('buttons.findMyBundle')}
      btnProps={{
        component: RouterLink,
        to: ROUTE_START,
        location: analyticsLocation,
      }}
    />
  );
}

BannerFMB.propTypes = {
  analyticsLocation: PropTypes.string.isRequired,
};

export default React.memo(BannerFMB);
